import { useContext, useEffect, useState } from 'react';
import Modal from 'react-modal';
import style from "./VirtualKeyboardModal.module.css";
import clsx from "classnames";
import backspaceIcon from "resources/img/puffu/backSpace.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import Dummy from 'components/Dummy';
import closeIcon from "resources/img/puffu/close.png";
import { requester } from 'App';
import { useParams } from 'react-router-dom';
import { CartReducer } from 'shared/redux/reducers/shopping/CartReducer';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { useDispatch } from 'react-redux';
import FlexChild from 'layouts/flex/FlexChild';
import Center from 'layouts/wrapper/Center';
import P from 'components/P';
import { BrowserDetectContext } from 'providers/BrowserEventProvider';
import DummyCard from '../../DummyCard';
import testProductBg from "resources/test/testProductBg.png";
import { toast } from 'react-toastify';


const Hangul = require('hangul-js');


function VirtyalKeyboardModal({ isOpen, onClose, detailYn, callback }) {
    const { id } = useParams();
    const [inputValue, setInputValue] = useState("");
    const [keyboardLayout, setKeyboardLayout] = useState('letters'); // 'letters', 'shifted', or 'numbers'
    const [searchResult, setSearchResult] = useState([]);
    const dispatch = useDispatch();
    const { isMobile } = useContext(BrowserDetectContext);

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'auto';
        // 모달이 닫힐 때 onClose 핸들러를 실행합니다.
        return () => {
            document.body.style.overflow = 'auto';
            onClose();
        };
    }, [isOpen, onClose]);

    const baseRows = [
        ['ㅂ', 'ㅈ', 'ㄷ', 'ㄱ', 'ㅅ', 'ㅛ', 'ㅕ', 'ㅑ', 'ㅐ', 'ㅔ'],
        ['ㅁ', 'ㄴ', 'ㅇ', 'ㄹ', 'ㅎ', 'ㅗ', 'ㅓ', 'ㅏ', 'ㅣ'],
        ['SHIFT', 'ㅋ', 'ㅌ', 'ㅊ', 'ㅍ', 'ㅠ', 'ㅜ', 'ㅡ', '백스페이스'],
        ['123', '간격', '검색']
    ];

    const shiftedRows = [
        ['ㅃ', 'ㅉ', 'ㄸ', 'ㄲ', 'ㅆ', 'ㅛ', 'ㅕ', 'ㅑ', 'ㅒ', 'ㅖ'],
        ...baseRows.slice(1) // 나머지 행은 그대로 유지
    ];
    const numberRows = [
        ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0',],
        [':', ';', '(', ')', '₩', '&', '@', '"'],
        ['.', ',', '?', '!', "'", '-', '/', '백스페이스',],
        ['123', '간격', '검색']
    ];

    const totalProducts = searchResult && searchResult.length;
    const dummyElementsCount = 4 - (totalProducts % 4);
    const dummyElements = searchResult && Array.from({ length: dummyElementsCount }).map((_, index) => (
        <div key={`dummy-${index}`} style={{ flex: "1 1 23%", opacity: 0 }}>
            <DummyCard data={{}} />
        </div>
    ));
    const SoldOutProductCard = (props) => {
        const { data } = props;
        const onClickProduct = () => {
            detailYn();
            // setDetailYn(true);
            const updatedData = { ...data, quantity: 1 };
            // setDetail(updatedData);
            callback(updatedData);
        }
        const addCartClick = () => {
            toast.error(`품절된 상품입니다`, {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }
        // const orderClick = () => {
        //     dispatch(CartReducer.actions.addProductToCart({ ...data, quantity: 1 }));
        //     NiceModal.show("payment", { id: id, onClose: paymentModalCallback, userName: userNameData });
        //     setIsModalOpen(true);
        // }
        return (
            <div
                style={{
                    display: "flex",
                    flex: "1 1 23%",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1.5px solid #bbb",
                    borderRadius: "3px"
                }}
            >
                <div
                    style={{
                        width: "100%",
                        position: "relative"
                    }}
                >
                    <VerticalFlex gap={10}>
                        <FlexChild>
                            <div style={{ pointerEvents: "none", position: "absolute", display: "flex", transform: "translateY(100px)", justifyContent: "center", alignItems: "center", zIndex: 0 }}>
                                <P font={"gmarketSansBold"} size={isMobile ? "2vw": 30} color={"var(--main-color)"}>SOLD OUT</P>
                            </div>
                            <div
                                style={{
                                    borderTopLeftRadius: "3px",
                                    borderTopRightRadius: "3px",
                                    padding: "10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundImage: data.productBgImg ? `url(${data.productBgImg})` : `url(${testProductBg})`,
                                    backgroundSize: "cover",
                                    opacity: 0.3,


                                }}
                                onClick={onClickProduct}
                            >
                                <img src={data.productImg} width={"100%"} />
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <Center>
                                <P ellipsis size={isMobile ? "1.7vw" : 15}>
                                    {data.productName}
                                </P>
                                <P font={"gmarketSansBold"} color={"var(--main-color)"} size={20}>
                                    {data.price ? data.price.toLocaleString() : '가격 없음'}원
                                </P>
                            </Center>
                        </FlexChild>
                        <FlexChild width={"100%"}>
                            <div style={{ backgroundColor: "var(--main-color)", cursor: "pointer" }} onClick={addCartClick}>
                                <Center>
                                    <P
                                        size={20}
                                        width={"100%"}
                                        color={"white"}
                                        padding={"7px 15px"}
                                        cursor={"pointer"}
                                        font={"gmarketSansBold"}
                                    >
                                        담기
                                    </P>
                                </Center>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </div>
            </div>
        );
    };


    const ProductCard = (props) => {
        const { data } = props;
        const onClickProduct = () => {
            detailYn();
            // setDetailYn(true);
            const updatedData = { ...data, quantity: 1 };
            // setDetail(updatedData);
            callback(updatedData);
        }
        const addCartClick = (event) => {
            event.stopPropagation()
            dispatch(CartReducer.actions.addProductToCart({ ...data, quantity: 1 }));
        }
        return (
            <div
                style={{
                    display: "flex",
                    flex: "1 1 23%",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1.5px solid #bbb",
                    borderRadius: "3px"
                }}
            >
                <div
                    style={{
                        width: "100%"
                    }}
                >
                    <VerticalFlex gap={10}>
                        <FlexChild>
                            <div
                                style={{
                                    borderTopLeftRadius: "3px",
                                    borderTopRightRadius: "3px",
                                    padding: "10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundImage: data.productBgImg ? `url(${data.productBgImg})` : `url(${testProductBg})`,
                                    backgroundSize: "cover"

                                }}
                                onClick={onClickProduct}
                            >
                                <img src={data.productImg} width={"100%"} />
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <Center>
                                <P ellipsis size={isMobile ? "1.7vw" : 15}>
                                    {data.productName}
                                </P>
                                <P font={"gmarketSansBold"} color={"var(--main-color)"} size={20}>
                                    {data.price ? data.price.toLocaleString() : '가격 없음'}원
                                </P>
                            </Center>
                        </FlexChild>
                        <FlexChild width={"100%"}>
                            <div style={{ backgroundColor: "var(--main-color)", cursor: "pointer" }} onClick={(event) => addCartClick(event)}>
                                <Center>
                                    <P
                                        size={20}
                                        width={"100%"}
                                        color={"white"}
                                        padding={"7px 15px"}
                                        cursor={"pointer"}
                                        font={"gmarketSansBold"}
                                    >
                                        담기
                                    </P>
                                </Center>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </div>
            </div>
        );
    };


    // 현재 활성화된 행을 결정
    const handleKeyClick = (key) => {
        if (key === 'SHIFT') {
            setKeyboardLayout(layout => layout === 'shifted' ? 'letters' : 'shifted');
        } else if (key === '123') {
            setKeyboardLayout(layout => layout === 'numbers' ? 'letters' : 'numbers');
        } else {

            // 입력값을 초성, 중성, 종성으로 분리
            const disassembledInput = Hangul.disassemble(inputValue);
            // 분리된 배열에 새로운 키 입력을 추가
            const newInput = [...disassembledInput, key];
            // 새로운 입력 배열을 다시 조합
            const assembledInput = Hangul.assemble(newInput);
            setInputValue(assembledInput);
            // setInputValue(prev => prev + key);

            // 쉬프트 상태가 활성화되어 있다면, 키 입력 후 쉬프트 상태 해제
            if (keyboardLayout === 'shifted') {
                setKeyboardLayout('letters');
            }
        }
    };
    const onDeleteInputClick = () => {
        setInputValue("");
    }
    const handleBackspace = () => {
        // 현재 입력값을 초성, 중성, 종성으로 분리
        const disassembledInput = Hangul.disassemble(inputValue);

        // 길이가 1보다 클 경우, 마지막 문자 처리
        if (disassembledInput.length > 1) {
            // 마지막 문자의 초성, 중성, 종성을 확인
            const lastCharIndex = disassembledInput.length - 1;
            const lastChar = disassembledInput[lastCharIndex];

            // 만약 마지막 문자가 완성된 한글이면, 한 번에 제거
            if (Hangul.isComplete(lastChar)) {
                // 마지막 문자 제거
                disassembledInput.splice(lastCharIndex - 2, 3); // 초성, 중성, 종성 한번에 제거
            } else {
                // 마지막 조합 문자 또는 자음/모음 제거
                disassembledInput.pop();
            }
        } else if (disassembledInput.length === 1) {
            // 입력값이 1글자인 경우 그냥 제거
            disassembledInput.pop();
        }

        // 수정된 배열을 다시 한글로 조합하여 입력값 업데이트
        const newInputValue = Hangul.assemble(disassembledInput);
        setInputValue(newInputValue);
    };
    const search = () => {
        let searchReq = {
            storeCode: id,
            productName: inputValue
        }
        requester.searchByStoreProduct(searchReq, (result) => {
            
            setSearchResult(result.data);
        })
    }

    const getCurrentRows = () => {
        switch (keyboardLayout) {
            case 'shifted':
                return shiftedRows;
            case 'numbers':
                return numberRows;
            default:
                return baseRows;
        }
    };
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Virtual Keyboard"
            className={style.modalContent}
            shouldCloseOnOverlayClick={false}
            overlayClassName={style.modalOverlay}
        >
            <div style={{ backgroundColor: "white", zIndex: 1 }}>
                <div className={style.inputArea}>
                    <input type="text" value={inputValue} readOnly className={style.keyboardInput} />
                    <img src={closeIcon} width={"25px"} className={style.inputDeleteBtn} onClick={onDeleteInputClick} />
                    <div className={style.searchArea}>
                        <FontAwesomeIcon icon={fas.faSearch} fontSize={20} color={"white"} size="xl" />
                    </div>
                    <div className={style.closeArea} onClick={onClose}>
                        <img src={closeIcon} width={"30px"} />
                    </div>
                </div>
                <Dummy height={"20px"} />
                <div className={style.keyboardContainer}>
                    {getCurrentRows().map((row, index) => (
                        <div className={style.row} key={index}>
                            {row.map(key => {
                                const keyClassName = clsx(style.key, {
                                    [style.specialKey]: ['SHIFT', '123', '간격', '검색'].includes(key),
                                    [style.spaceKey]: key === '간격',
                                    [style.shiftKey]: key === 'SHIFT',
                                    [style.enterKey]: key === '검색',
                                    [style.backspaceKey]: key === '백스페이스',
                                    [style.shiftActive]: key === 'SHIFT' && keyboardLayout === 'shifted',
                                    [style.numberActive]: key === '123' && keyboardLayout === 'numbers',
                                });

                                if (key === '백스페이스') {
                                    return (
                                        <div className={keyClassName} key={key} onClick={handleBackspace}>
                                            <img src={backspaceIcon} width={"30px"} alt="Backspace" />
                                        </div>
                                    );
                                } else if (key === '검색') {
                                    return <p className={keyClassName} key={key} onClick={search}>{key}</p>;
                                }
                                return <p className={keyClassName} key={key} onClick={() => handleKeyClick(key)}>{key}</p>;
                            })}
                        </div>
                    ))}
                </div>
                <Dummy height={"20px"} />
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: "15px",
                        padding: "0 15px"

                    }}
                >
                    {
                        searchResult &&
                        searchResult.map((row, index) => {
                            return (
                                row.quantity > 0
                                    ?
                                    <ProductCard data={row} />
                                    :
                                    <SoldOutProductCard data={row} realQuantity={row.quantity} />
                            );
                        })
                    }
                    {totalProducts % 4 !== 0 && dummyElements}
                </div>

            </div>
        </Modal>
    );

}

export default VirtyalKeyboardModal;